/**
 * Takes in a use resource object. Requires a subset of items that have ordinals.
 * takes the items and reorders them and sends an update to the back end as well
 * as optimistically updating the front end.
 *
 * @param prevPos the array position of the moved item
 * @param newPos the new array position of the moved item
 * @param mainObj the useResource Object that contains the movingObjs
 * @param movingObjs the whole list of objects that the reorder is happening in
 * @param idName the name of the id fields to be used to identify the subObject (usually just "id")
 * @param firstLayer the name of the first layer in the updatePackage obj (ex: "overview")
 * @param secondLayer the name of the second layer in the updatePackage obj (ex: "tile_entries_attributes")
 */
export function handleMoveChildren({
  prevPos,
  newPos,
  mainObj,
  movingObjs,
  idName,
  firstLayer,
  secondLayer,
}) {
  const [element] = movingObjs.splice(prevPos, 1)
  movingObjs.splice(newPos, 0, element)

  const updatedMovingObjs = movingObjs.map((obj, index) => {
    return { id: obj[idName], ordinal: index + 1 }
  })

  // Update local cache with new data to prevent re-rendering
  // Assumes the back-end call was successful
  mainObj.updateLocal(mainObj, updatedMovingObjs)

  mainObj.update({
    [firstLayer]: {
      [secondLayer]: updatedMovingObjs,
    },
  })
}
